/**
 * @generated SignedSource<<b6d18eb94cf15d0b57ef0b8be21ac9cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Datepicker_text$data = {
  readonly headercols: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly presetdatetexts: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly savebuttontext: string | null | undefined;
  readonly " $fragmentType": "Datepicker_text";
};
export type Datepicker_text$key = {
  readonly " $data"?: Datepicker_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"Datepicker_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Datepicker_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presetdatetexts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headercols",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "savebuttontext",
      "storageKey": null
    }
  ],
  "type": "PerformanceOverviewDatepicker",
  "abstractKey": null
};

(node as any).hash = "9ec78f53f59557dd3d7ad741d2f3e84d";

export default node;
